<div class="card-base">
    <div class="card-content-search">
        <div class="card-container">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-laboratory-tubes-filter #filters></app-laboratory-tubes-filter>
                </div>
                <div class="pull-right div-header-right">
                    <mat-spinner *ngIf="loadingMasiveAction" diameter="50"> </mat-spinner>
                    <button *ngIf="!loadingMasiveAction" class="card-inline margin-top-medium" [matMenuTriggerFor]="menuItem" type="button" mat-mini-fab>
            <mat-icon>more_vert</mat-icon>
          </button>

                    <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
                    <mat-menu #menuItem="matMenu">
                        <button (click)="setAcepted()" mat-menu-item>
              <span> <b>Aceptar</b></span>
            </button>
                        <button (click)="setRejected()" mat-menu-item>
              <span> <b>Rechazar</b></span>
            </button>
                        <button (click)="revertStatus()" mat-menu-item>
              <span> <b>Revertir</b></span>
            </button>
                    </mat-menu>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
                    <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="Select">
                            <th class="checkbox-column" mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                                </mat-checkbox>
                            </th>
                            <td class="checkbox-column" mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Date">
                            <th class="s resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Fecha" #resColReceptionDate></resizable-column-control>
                            </th>
                            <td style="width: 60px" class="search-table-header resizable-column" mat-cell *matCellDef="let element">
                                <div>{{ element.Date | date : "dd/MM/yyyy HH:mm" }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="State">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Estado" #resColState></resizable-column-control>
                            </th>
                            <td class="search-table-header resizable-column" mat-cell *matCellDef="let element">
                                <div>{{ element.Status }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="PatientDocument">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Identificacion" #resColPatientDocument></resizable-column-control>
                            </th>
                            <td class="search-table-header resizable-column" mat-cell *matCellDef="let element">
                                <div>{{ element.Patient }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Identification">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Tubo" #resColIdentfication></resizable-column-control>
                            </th>
                            <td class="search-table-header resizable-column" mat-cell *matCellDef="let element">
                                <div>{{ element.Tube }}</div>
                            </td>
                        </ng-container>

                        <!-- Star Column -->
                        <ng-container matColumnDef="Star" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-header resizable-column" mat-cell *matCellDef="let element">
                                <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>

                                <button *ngIf="!element.Loading" mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                                <mat-menu #menuItem="matMenu">
                                    <button (click)="control(element)" mat-menu-item>
                    <span>Controlar</span>
                  </button>
                                    <button (click)="viewControls(element)" mat-menu-item>
                    <span>Ver observaciones</span>
                  </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row [ngClass]="{
                'no-reserved': row.CanStartAttention,
                'search-table-cell': true
              }" *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>